import { Grid } from '@mui/material';
import { Container } from '@mui/system';

function HeaderWidget(props) {
	return (
		<div className="w-full">
			<div className="">
				<div className="w-full max-w-2xl mx-auto">
					{props.headingTag === 'p' || props.headingTag === 'ol' ? (
						<div className="mt-16 mx-auto">
							<div dangerouslySetInnerHTML={{ __html: props.mainTitle }} />
						</div>
					) : props.headingTag === 'table' ? (
						<table className="disclosure" dangerouslySetInnerHTML={{ __html: props.mainTitle }} />
					) : (
						<div className="mt-16 mx-auto">
							<div dangerouslySetInnerHTML={{ __html: props.mainTitle }} />
						</div>
					)}

					<Grid variants={Container} className="flex items-center justify-center flex-wrap" />
				</div>
			</div>
		</div>
	);
}

export default HeaderWidget;
